import * as Yup from "yup";

export const employeeWorkHoursSchema = Yup.object().shape({
  employee_id: Yup.number()
    .required("Funcionário é obrigatório")
    .typeError("Funcionário deve ser um número"),

  days: Yup.array()
    .of(
      Yup.object().shape({
        day_of_week_id: Yup.array() // ✅ Array de números
          .of(Yup.number().typeError("ID do dia da semana deve ser um número"))
          .min(1, "Selecione pelo menos um dia da semana")
          .required("Dias da semana são obrigatórios"),

        is_day_off: Yup.boolean().required('Campo "folga" é obrigatório'),

        work_start: Yup.string()
          .nullable()
          .when("is_day_off", {
            is: false,
            then: (schema) =>
              schema
                .required("Horário de início do trabalho é obrigatório")
                .matches(/^\d{2}:\d{2}$/, "Formato inválido. Use HH:mm"),
            otherwise: (schema) => schema.nullable(),
          }),

        work_end: Yup.string()
          .nullable()
          .when("is_day_off", {
            is: false,
            then: (schema) =>
              schema
                .required("Horário de término do trabalho é obrigatório")
                .matches(/^\d{2}:\d{2}$/, "Formato inválido. Use HH:mm"),
            otherwise: (schema) => schema.nullable(),
          }),

        lunch_start: Yup.string()
          .nullable()
          .when("is_day_off", {
            is: false,
            then: (schema) =>
              schema
                .nullable()
                .test(
                  "format",
                  "Formato inválido. Use HH:mm",
                  function (value) {
                    if (!value) return true;
                    return /^\d{2}:\d{2}$/.test(value);
                  },
                ),
            otherwise: (schema) => schema.nullable(),
          }),

        lunch_end: Yup.string()
          .nullable()
          .when("is_day_off", {
            is: false,
            then: (schema) =>
              schema
                .nullable()
                .test(
                  "format",
                  "Formato inválido. Use HH:mm",
                  function (value) {
                    if (!value) return true; // Se está vazio, é válido (opcional)
                    return /^\d{2}:\d{2}$/.test(value);
                  },
                ),
            otherwise: (schema) => schema.nullable(),
          }),
      }),
    )
    .required("Dias da semana são obrigatórios")
    .min(1, "Selecione ao menos um dia da semana"),
});
